import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getStepByIndexFunc, getIsStepActiveFunc } from 'services/stepper/selectors'
import { goNextStep } from 'services/stepper/actions'

export default function useStep({ stepIndex }) {
  const dispatch = useDispatch()

  const getStepByIndex = useSelector(getStepByIndexFunc)
  const getIsStepActive = useSelector(getIsStepActiveFunc)

  const step = getStepByIndex(stepIndex)
  const isStepActive = getIsStepActive(stepIndex)

  useEffect(() => {
    if (isStepActive && step?.isDisabled) {
      dispatch(goNextStep())
    }
  }, [dispatch, isStepActive, step?.isDisabled])

  return { ...step, isActive: isStepActive }
}
